import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { isDeletedColumn, rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";

export class ItemChangePoints extends BookIndex {
    get tableColumns() {
        const restoreAction = (id) => {
            this.props.modal({
                name: "confirm",
                title: "Вы действительно хотите восстановить?",
                action: () => this.props.source.restore({ id }).then(() => this.props.mergeParams({})),
                buttons: { confirm: "Да", cancel: "Нет" },
            });
        };

        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                sortable: true,
                Cell: ({ value, row: { original } }) => {
                    return <Link to={paths.itemChangePointsShow(original.id)}>{value}</Link>;
                },
            },
            {
                Header: "Адрес",
                accessor: "geozone",
                id: "geozone/address",
                filterable: true,
                sortKey: "geozone/address",
                Cell: ({ value }) => value.address,
            },
            isDeletedColumn(restoreAction, true),
        ];
    }

    renderListComponent = () => {
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
    };

    renderCreateButton = () => {
        const { modal, mergeParams } = this.props;
        const action = () =>
            modal({
                name: "createItemChangePoint",
                title: "Создание адреса перецепки",
                mergeParams,
            });
        return (
            <a className="btn btn-brand btn-sm" onClick={action}>
                Создать адрес перецепки
            </a>
        );
    };
}

export default tableContainer(ItemChangePoints, "item-change-points");
